(function () {
  'use strict';

  var config = window.VLSAgeGate;
  var dialog = document.getElementById('vls-age-gate');
  if (!config || !dialog || config.initialized) return;
  config.initialized = true;

  var key = config.key || 'vls_age_confirmed_21_v1';
  var html = document.documentElement;
  var nativeDialog = typeof dialog.showModal === 'function';
  var lastFocus = null;
  var savedScroll = null;
  var leaving = false;
  var fallbackInert = [];

  function accepted(value) {
    return value === '1' || value === 'true';
  }

  function readConfirmation() {
    try {
      if (accepted(window.localStorage.getItem(key))) return true;
    } catch (error) {  }
    try {
      if (accepted(window.sessionStorage.getItem(key))) return true;
    } catch (error) {  }
    try {
      var prefix = encodeURIComponent(key) + '=';
      return document.cookie.split(';').some(function (cookie) {
        cookie = cookie.trim();
        return cookie.indexOf(prefix) === 0 && accepted(decodeURIComponent(cookie.slice(prefix.length)));
      });
    } catch (error) {
      return false;
    }
  }

  function rememberConfirmation() {

    config.confirmed = true;
    try { window.localStorage.setItem(key, '1'); } catch (error) {  }
    try { window.sessionStorage.setItem(key, '1'); } catch (error) {  }
    try {
      document.cookie = encodeURIComponent(key) + '=1; Path=/; Max-Age=31536000; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (error) {  }
  }

  function isConfirmed() {
    if (config.confirmed === true) return true;
    config.confirmed = readConfirmation();
    return config.confirmed;
  }

  function focusWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') return;
    try { element.focus({ preventScroll: true }); } catch (error) { element.focus(); }
  }

  function setFallbackInert() {
    fallbackInert = [];
    Array.prototype.forEach.call(document.body.children, function (element) {
      if (element === dialog || element.contains(dialog)) return;
      if (/^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
      fallbackInert.push({ element: element, inert: element.inert });
      element.inert = true;
    });
  }

  function restoreFallbackInert() {
    fallbackInert.forEach(function (entry) { entry.element.inert = entry.inert; });
    fallbackInert = [];
  }

  function focusTitle() {
    var title = dialog.querySelector('#vls-age-gate-title, .vls-age-gate__title, h1, h2, h3') || dialog;
    if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
    focusWithoutScroll(title);
  }

  function openGate() {
    if (isConfirmed() || leaving) return;
    if (!savedScroll) {
      savedScroll = { x: window.scrollX, y: window.scrollY };
      lastFocus = document.activeElement;
      if (lastFocus && dialog.contains(lastFocus)) lastFocus = null;
    }
    html.classList.add('vls-age-gate-open');
    if (!dialog.open) {
      if (nativeDialog) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        setFallbackInert();
      }
    }
    focusTitle();
  }

  function restorePage() {
    var wasOpen = dialog.open || savedScroll !== null;
    html.classList.remove('vls-age-gate-pending', 'vls-age-gate-open');
    if (nativeDialog && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    restoreFallbackInert();
    if (!wasOpen) return;

    var focusTarget = lastFocus;
    if (!focusTarget || !focusTarget.isConnected || focusTarget === document.body || dialog.contains(focusTarget)) {
      focusTarget = document.querySelector('#MainContent h1, main h1, #MainContent, main');
      if (focusTarget && !focusTarget.hasAttribute('tabindex')) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.addEventListener('blur', function removeTemporaryTabindex() {
          focusTarget.removeAttribute('tabindex');
        }, { once: true });
      }
    }
    focusWithoutScroll(focusTarget);
    if (savedScroll) window.scrollTo(savedScroll.x, savedScroll.y);
    savedScroll = null;
    lastFocus = null;
  }

  function leaveSection() {
    if (leaving) return;
    leaving = true;
    var destination = '/';
    try {
      var root = new URL(config.rootUrl || '/', window.location.origin);
      if (root.origin === window.location.origin) destination = root.href;
    } catch (error) {  }
    window.location.assign(destination);
  }

  function restrictedMarker(target) {
    var element = target && (target.nodeType === 1 ? target : target.parentElement);
    return element && element.closest('[data-vls-age-restricted="true"]');
  }

  function protectRestrictedAction(event) {
    if (!restrictedMarker(event.target) || isConfirmed()) return;
    if (event.type === 'click') {
      var element = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
      if (!element || !element.closest('button.quick-add__submit, button[data-product-url], form button[type="submit"], form button:not([type]), form input[type="submit"], form input[type="image"]')) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    openGate();
  }

  dialog.addEventListener('click', function (event) {
    var element = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
    if (!element) return;
    if (element.closest('[data-vls-age-confirm]')) {
      event.preventDefault();
      rememberConfirmation();
      restorePage();
    } else if (element.closest('[data-vls-age-leave]')) {
      event.preventDefault();
      leaveSection();
    }
  });

  dialog.addEventListener('cancel', function (event) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    leaveSection();
  });

  dialog.addEventListener('close', function () {
    if (!config.confirmed && !leaving) openGate();
  });

  dialog.addEventListener('keydown', function (event) {
    if (nativeDialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      leaveSection();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
    if (!focusable.length) {
      event.preventDefault();
      focusWithoutScroll(dialog);
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !Array.prototype.includes.call(focusable, document.activeElement))) {
      event.preventDefault();
      focusWithoutScroll(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusWithoutScroll(first);
    }
  });

  document.addEventListener('click', protectRestrictedAction, true);
  document.addEventListener('submit', protectRestrictedAction, true);
  document.addEventListener('focusin', function (event) {
    if (!nativeDialog && dialog.open && !dialog.contains(event.target)) focusTitle();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === key && accepted(event.newValue)) {
      config.confirmed = true;
      if (dialog.open) restorePage();
    }
  });

  if (isConfirmed()) {

    restorePage();
  } else if (config.restricted || dialog.open) {
    openGate();
  } else {
    html.classList.remove('vls-age-gate-pending');
  }
})();
